export enum LangEnum {
  VI = "vi",
  EN = "en",
}

export enum DateTimeEnum {
  DD_MM_YYYY_HH_MM_SS_Z = "DD/MM/YYYY HH:mm:ssZ",
  YYYY_MM_DD_HH_MM_SS_Z = "YYYY/MM/DD HH:mm:ssZ",
}

export enum StatusCode {
  SUCCESS = "SUCCESS",
  FAIL = "FAIL",
}

export enum GroupEnum {
  ADMIN = "ADMIN",
  MERCHANT = "MERCHANT",
  CUSTOMER = "CUSTOMER",
}

export enum BlockTypeEnum {
  CONTENT = "CONTENT",
  HERO_BANNER = "HERO_BANNER",
  FAQ = "FAQ",
  QUOTE = "QUOTE",
  SLIDER = "SLIDER",
  IMAGE_TEXT = "IMAGE_TEXT",
  VIDEO = "VIDEO",
  LIST = "LIST",
}
